module.exports = require("./sk.d.ts");